import { useState, useEffect, Dispatch, SetStateAction } from 'react';
//TODO make initialValue T
export function useSessionStorageState<T>(key: string, initialValue: T, isDate?: boolean): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      if (isDate ?? false) {
        const storeVal = window.sessionStorage.getItem(key);
        if (storeVal === 'null') {
          return initialValue;
        } else {
          const storedDateTime = Number.parseInt(window.sessionStorage.getItem(key) ?? (initialValue as Date).getTime().toString());
          console.log('storedDate', storedDateTime, Date.now())
          return new Date(storedDateTime);
        }
      }
      return JSON.parse(window.sessionStorage.getItem(key) ?? initialValue as string);
    } catch (err) {
      return initialValue;
    }
  });

  useEffect(() => {
    window.sessionStorage.setItem(key, JSON.stringify(isDate ? (value as Date).getTime() : value));
  }, [key, value, isDate]);

  return [value, setValue];
}
